import React from "react";

const OrderExpandRow = ({ order }) => {
  return (
    <>
      <tr className="border ">
        <td colSpan="10" className="p-2">
          <div className="flex">
            <table className="w-full text-sm text-left text-gray-400">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                <tr>
                  <td className="px-6 py-3 text-center">سعر المنتج بالعراقي</td>
                  <td className="px-6 py-3 text-center">الكمية</td>
                  <td className="px-6 py-3 text-center">الإسم</td>
                  <td className="px-6 py-3">صورة المنتج</td>
                </tr>
              </thead>
              <tbody>
                {order.items.map((item) => {
                  return (
                    <tr className="bg-gray-100 border-b" key={item.itemsId}>
                      <th className="px-6 py-3 text-center">{item.itemsIRAQIprice}</th>
                      <th className="px-6 py-3 text-center">{item.qty}</th>
                      <th className="px-6 py-3 text-center">{item.itemsName}</th>

                      <th className="px-6 py-3">
                        <img
                          src={`${process.env.REACT_APP_IMAGE_URL}/${item.itemsId}.png`}
                          alt="Item "
                          className="w-16 h-16 object-cover  text-center"
                        />
                      </th>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </td>
      </tr>
    </>
  );
};

export default OrderExpandRow;
